export const configurationSource =
  "https://raw.githubusercontent.com/mild-blue/about/refs/heads/master/health-warden.config.json";
